/**
 * 元码科技标签接口参数与映射
 * @see https://www.anqicms.com/anqiapi-tag/147.html
 * @see https://www.anqicms.com/anqiapi-tag/148.html
 * @see https://www.anqicms.com/anqiapi-tag/149.html
 */

export function isNumericId(value) {
  return /^\d+$/.test(String(value))
}

/** 标签列表 /api/tag/list */
export function buildTagListParams(options = {}) {
  const { itemId, letter, type = 'list', page = 1, limit = 100 } = options
  const params = { type, limit }

  if (type === 'page') params.page = page
  if (itemId) params.itemId = itemId
  if (letter) params.letter = letter

  return params
}

/** 标签详情 /api/tag/detail */
export function buildTagDetailParams(options = {}) {
  const { id, filename } = options
  const params = {}

  if (id !== undefined && id !== null && id !== '') {
    params.id = id
  }
  if (filename) {
    params.filename = filename
  }

  return params
}

/** 标签文档列表 /api/tag/data/list */
export function buildTagDataListParams(options = {}) {
  const {
    id,
    filename,
    order = 'created_time desc',
    type = 'page',
    page = 1,
    limit = 10
  } = options

  const params = { order, type, limit }

  if (type === 'page') params.page = page
  if (id !== undefined && id !== null && id !== '') {
    params.id = id
  }
  if (filename) {
    params.filename = filename
  }

  return params
}

export function resolveTagQuery(value) {
  if (!value) return {}
  if (isNumericId(value)) {
    return { id: value }
  }
  return { filename: value }
}

export function mapTagItem(item) {
  if (!item) return null
  return {
    id: item.id,
    title: item.title || '',
    seoTitle: item.seo_title || item.seoTitle || '',
    urlToken: item.url_token || item.urlToken || '',
    keywords: item.keywords || '',
    description: item.description || '',
    firstLetter: item.first_letter || item.firstLetter || '',
    link: item.link || ''
  }
}

export function mapTagList(list) {
  if (!Array.isArray(list)) return []
  return list.map(mapTagItem).filter(Boolean)
}
